import i18next from 'util/i18next/i18next'
import PropTypes from 'prop-types'
import React from 'react'

import Button from 'components/Button/Button'
import { setJsonLocalStorage } from 'util/UtilLocalStorage/UtilLocalStorage'

const i18nBase = 'DragGraphButton'

function DragGraphButton({
  buttonSize,
  graphKey,
  isDisabled,
  isSelected,
  k,
  persisted,
  newValue,
  onClick,
}) {
  return (
    <Button
      isSelected={isSelected}
      isDisabled={isDisabled}
      size={buttonSize}
      label={i18next.t(`${i18nBase}.${k}`)}
      onClick={() => {
          persisted && setJsonLocalStorage({ k: graphKey, v: {
            ...persisted,
          [k]: newValue,
        } })
        onClick(newValue)
      }}
    />
  )
}

DragGraphButton.defaultProps = {
  buttonSize: 'medium',
}

DragGraphButton.propTypes = {
  heading: PropTypes.string,
  scaleDetail: PropTypes.string,
  onClick: PropTypes.func,
}

export default DragGraphButton
